import React from 'react';

const FrameViewer = ({ url = '' }) => {
    return (
        <div className="w-full h-screen border border-gray-300">
            {url ? (
                <iframe
                    src={url}
                    title="Frame Viewer"
                    className="w-full h-full"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            ) : (
                <p className="text-center text-gray-500 mt-4">No URL provided</p>
            )}
        </div>
    );
}

export default FrameViewer;
